export const BANNER_INTERVAL = 7000;
export const TIMEOUT_AFTER_MANUAL_SWIPE = 15000;
export const SLIDER_ON = true;
